import { render } from "./DomiciliationRenewHistory.vue?vue&type=template&id=67f09d44&scoped=true"
import script from "./DomiciliationRenewHistory.vue?vue&type=script&lang=js"
export * from "./DomiciliationRenewHistory.vue?vue&type=script&lang=js"

import "./DomiciliationRenewHistory.vue?vue&type=style&index=0&id=67f09d44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f09d44"]])

export default __exports__